import { PropsWithChildren, ReactNode } from "react"
import { classNames, classNamesOrEmpty } from "../../style/common"

export type LabelProps = PropsWithChildren & {
  label: string,
  labelElement?: ReactNode,
  size?: "sm" | "md" | "lg",
  classNames?: {
    container?: string | undefined,
    childrenContainer?: string | undefined,
    label?: string | undefined
  }
}

export function Label(props: LabelProps) {
  return (
    <div className={classNamesOrEmpty(props?.classNames?.container)}>
      <div className="flex items-center justify-between">
        <h2
          className={classNames(
            `font-medium leading-3`,
            !props.size && "text-sm",
            props.size === "sm" && "text-sm",
            props.size === "md" && "text-md",
            props.size === "lg" && "text-lg",
            props?.classNames?.label
          )}
        >
          {props.labelElement ? props.labelElement : props.label}
        </h2>
      </div>

      <div className={classNames("mt-2", props.classNames?.childrenContainer)}>
        {props.children}
      </div>
    </div>
  )
}